// import littleBirdInTheAgeOfCorona from "./linocuts/little-bird-in-the-age-of-corona.jpg";
import artemis from "./linocuts/artemis.jpg";
import beyondTimeRed from "./linocuts/beyond-time-red.jpg";
import beyondTime from "./linocuts/beyond-time.jpg";
import catsNDogs from "./linocuts/cats-n-dogs.jpg";
import elements from "./linocuts/elements.jpg";
import fairytale from "./linocuts/fairytale.jpg";
import girlpower from "./linocuts/girlpower.jpg";
import gooMoon from "./linocuts/goo-moon.jpg";
import iWillRemain from "./linocuts/i-will-remain.jpg";
import mice from "./linocuts/mice.jpg";
import ohHolyBird from "./linocuts/oh-holy-bird.jpg";
import theThreeBillyGoatsGruffAndOlleBolle from "./linocuts/the-three-billy-goats-gruff-and-olle-bolle.jpg";
import theTow from "./linocuts/the-tow.jpg";
import vanity from "./linocuts/vanity.jpg";
import wrongPlanet from "./linocuts/wrong-planet-lino.jpg";

export const linocuts = [
  {
    title: "The Tow",
    date: "2016",
    size: "20x30",
    imageUrl: theTow,
    imageUrlSmall: theTow,
    prints: 20,
  },
  {
    title: "Vanity",
    date: "2016",
    size: "20x30",
    imageUrl: vanity,
    imageUrlSmall: vanity,
    prints: 20,
  },
  {
    title: "Oh Holy Bird",
    date: "2016",
    size: "20x30",
    imageUrl: ohHolyBird,
    imageUrlSmall: ohHolyBird,
    prints: 20,
  },
  {
    title: "Artemis",
    date: "2020",
    size: "30x40",
    imageUrl: artemis,
    imageUrlSmall: artemis,
    prints: 25,
  },
  {
    title: "Beyond Time",
    date: "2020",
    size: "30x40",
    imageUrl: beyondTime,
    imageUrlSmall: beyondTime,
    prints: 25,
  },
  {
    title: "Beyond Time Red",
    date: "2020",
    size: "30x40",
    imageUrl: beyondTimeRed,
    imageUrlSmall: beyondTimeRed,
    prints: 20,
  },
  {
    title: "Goo Moon",
    date: "2020",
    size: "30x40",
    imageUrl: gooMoon,
    imageUrlSmall: gooMoon,
    prints: 25,
  },
  {
    title: "I Will Remain...",
    date: "2020",
    size: "30x40",
    imageUrl: iWillRemain,
    imageUrlSmall: iWillRemain,
    prints: 25,
  },
  {
    title: "Elements",
    date: "2025",
    size: "30x40",
    imageUrl: elements,
    imageUrlSmall: elements,
    prints: 25,
    handcolored: true,
  },
  {
    title: "Cats'n'Dogs",
    date: "2022",
    size: "20x27",
    imageUrl: catsNDogs,
    imageUrlSmall: catsNDogs,
    prints: 20,
    handcolored: true,
  },
  {
    title: "Girlpower",
    date: "2022",
    size: "20x27",
    imageUrl: girlpower,
    imageUrlSmall: girlpower,
    prints: 20,
    handcolored: true,
  },
  {
    title: "Mice",
    date: "2022",
    size: "20x27",
    imageUrl: mice,
    imageUrlSmall: mice,
    prints: 20,
    handcolored: true,
  },
  {
    title: "Fairytale",
    date: "2018",
    size: "40x30",
    imageUrl: fairytale,
    imageUrlSmall: fairytale,
  },
  {
    title: "Wrong Planet",
    date: "2025",
    size: "40x30",
    imageUrl: wrongPlanet,
    imageUrlSmall: wrongPlanet,
  },
  {
    title: "The Three Billy Goats Gruff and Olle Bolle",
    date: "2018",
    size: "40x30",
    imageUrl: theThreeBillyGoatsGruffAndOlleBolle,
    imageUrlSmall: theThreeBillyGoatsGruffAndOlleBolle,
  },
];

//   {
//   title: "Little Bird in the Age of Corona",
//   date: "2020",
//   size: "30x40",
//   imageUrl: littleBirdInTheAgeOfCorona,
//   imageUrlSmall: littleBirdInTheAgeOfCorona,
//   prints: 25,
//   handcolored: true,
// },
